import { c as _c } from "react/compiler-runtime";
import { ContactDetails } from '@/components/Atoms/ContactDetails/ContactDetails';
import { Prose } from '@/components/Atoms/Prose/Prose';
import type { IDialogControl } from '@/components/Molecules/Dialog/Dialog';
import { Dialog } from '@/components/Molecules/Dialog/Dialog';
import useTranslation from '@/hooks/useTranslation';
import type { FC } from 'react';
export type LimitMessageKey = 'insight' | 'data';
interface IProps {
  dialog: IDialogControl;
  limitMessageKey: LimitMessageKey;
}
export const LimitReachedDialog: FC<IProps> = t0 => {
  const $ = _c(12);
  const {
    dialog,
    limitMessageKey
  } = t0;
  const {
    t
  } = useTranslation("insights");
  let t1;
  if ($[0] !== t) {
    t1 = t("insights:InsightExecSumActions.limitReachedTitle");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `insights:InsightExecSumActions.limitReachedText.${limitMessageKey}`;
  let t3;
  if ($[2] !== t || $[3] !== t2) {
    t3 = t(t2);
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Prose><p>{t3}</p></Prose>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ContactDetails />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== dialog || $[9] !== t1 || $[10] !== t4) {
    t6 = <Dialog {...dialog} title={t1}>{t4}{t5}</Dialog>;
    $[8] = dialog;
    $[9] = t1;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};